
















import { Vue, Component, Constructor } from 'vue-property-decorator'
import Onboarding from '@/util/Onboarding'
import Locker from '@/util/Locker'
import { Nullable } from '@/types/general'
import { setPageTitle } from '@/util/Helpers'
import VPage from '@/components/pages/VPage.vue'

import OnboardOption from './register/OnboardOption.vue'
import UserDetails from './register/UserDetails.vue'
import MasterPassword from './register/MasterPassword.vue'
import SecretKey from './register/SecretKey.vue'

@Component({ name: 'register', components: { VPage } })
export default class Register extends Vue {
    /**
     * Register component part to display
     */
    component: Nullable<Constructor> = OnboardOption

    /**
     * Loading message to display between components
     */
    loadingMessage: string = ''

    mounted(): void {
        setPageTitle('Register')
        // kill the locker interval
        Locker.endInterval()
    }

    /**
     * Move to user detail components
     */
    optionComplete(): void {
        this.component = UserDetails
    }

    /**
     * Move to master password component
     */
    userDetailsComplete(data: { email: string, username: string }): void {
        this.component = null
        Onboarding.setUserDetails(data.email, data.username)
        this.loadingMessage = 'Cool! Moving on...'
        this.component = MasterPassword
    }

    /**
     * Move to secret key display components
     */
    async masterPasswordComplete(): Promise<void> {
        this.component = null
        this.loadingMessage = 'Your keys are ready! Just checking with the server...'
        await Onboarding.register()
        this.loadingMessage = 'Almost there...'
        await Onboarding.createDefaults()
        this.component = SecretKey
    }

    /**
     * Move back a component
     */
    back(): void {
        if (this.component === UserDetails) {
            this.component = OnboardOption
        }
        if (this.component === MasterPassword) {
            this.component = UserDetails
        }
    }
}
